













































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import {PartnerUserRolesItem} from "@/store/user_management/partner_user_roles/types";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import PartnerUserRolesFilter from "@/components/UserManagement/PartnerUserRoles/PartnerUserRolesFilter.vue";

@Component({components:{PartnerUserRolesFilter, ScrollButton}})
export default class PartnerUserRoles extends BaseItemsPage<PartnerUserRolesItem> {
  @Getter("partnerUserRoles") userRolesResponse: any;
  private is_show_filter = false;
  currentSort= "name";
  currentSortOrder= "desc";
  tableFields = [
    'name',
  ];

  getData(): any {
    return this.userRolesResponse;
  }
}
